export const wholeNumberParams = ['numPMIDsupportingAssociation', 'shared_genes', 'shared_variants'];
